<template>
    <div class="flex flex-col items-center justify-between w-7 h-4">
        <span class="border-b-2 border-white w-full rounded-sm"></span>
        <span class="border-b-2 border-white w-9/12 rounded-sm"></span>
        <span class="border-b-2 border-white w-full rounded-sm"></span>
    </div>
</template>
